import React, { useState } from 'react';
import LocationContractCyclesTabs from './components/CycleTabs/LocationContractCyclesTabs';
import { NO_TAB_SELECTED } from '../ContractScreensView/constants';
import LocationContractOverviewRouter from './components/TabRouter/LocationContractOverviewRouter';
import OverviewTopActions from './components/OverviewTopActions/OverviewTopActions';
import { useLocation } from 'react-router-dom';
import Search from '../../components/Cycle/Search';
import { connect } from 'react-redux';
import { mapDispatch } from './constants/store';
import { LocationContractOverviewProps } from './types/LocationContractOverviewProps.type';
import ColumnVisibilityMenu from '../../components/ScreenCyclesTable/ColumnVisibilityMenu';

const LocationContractOverview: React.FC<LocationContractOverviewProps> = ({ setSearchCycleQuery }) => {
  const location = useLocation();
  const data: { tabNumber?: number } | null = location.state;
  const defaultTabNumberValue = (data && 'tabNumber' in data)
    ? Number(data.tabNumber)
    : NO_TAB_SELECTED;
  const cycleTabStatePayload = useState<number>(defaultTabNumberValue);

  return (
    <div className="p-location-contract-overview flex h-full w-full flex-col pb-4 md:pb-8">
      <div className="flex justify-end">
        <ColumnVisibilityMenu />
      </div>
      <OverviewTopActions />
      <LocationContractCyclesTabs tabStatePayload={cycleTabStatePayload} />
      <Search onSearch={setSearchCycleQuery} />
      <LocationContractOverviewRouter tabNumber={cycleTabStatePayload[0]} />
    </div>
  )
};

export default connect(null, mapDispatch)(LocationContractOverview);
